import type { Dictionary } from '../i18n.js';

export const shelves: Dictionary = {
  // frontDoor.ts
  Tours: 'Turnieje',
  'Quick race': 'Szybki wyścig',
  Yours: 'Twoje',
  'Race entry': 'Zgłoszenie do wyścigu',
  Join: 'Dołącz',
  'Search tours, cities, people': 'Szukaj turniejów, miast, osób',
  'Who is driving?': 'Kto za kierownicą?',
  'Start a lobby': 'Załóż lobby',
  'Driver name': 'Imię kierowcy',
  'Car colour': 'Kolor auta',
  'Have an account? ': 'Masz konto? ',
  ' — your name comes with it.': ' — imię wczyta się samo.',
  Host: 'Gospodarz',
  'Create a lobby': 'Utwórz lobby',
  'Pick a tour or a city to race. You get a four-letter code to send to everyone else.':
    'Wybierz turniej albo miasto. Dostaniesz czteroznakowy kod, który roześlesz reszcie.',
  'Choose what to race': 'Wybierz, gdzie się ścigacie',
  Guest: 'Gość',
  'Join a lobby': 'Dołącz do lobby',
  'Somebody sent you a code? Type it here.': 'Ktoś przysłał ci kod? Wpisz go tutaj.',
  'Create a lobby — what are we racing?': 'Utwórz lobby — gdzie się ścigamy?',
  'Nothing matches that.': 'Nic nie pasuje do wyszukiwania.',
  'No tours yet. Build one and it is on this shelf for everybody.':
    'Nie ma jeszcze żadnych turniejów. Zbuduj własny, a trafi na tę półkę dla wszystkich.',
  'Draw your own': 'Narysuj własny',
  'Sign in to build tours of your own.': 'Zaloguj się, żeby tworzyć własne turnieje.',
  'Any streets on Earth, step by step': 'Dowolne ulice na Ziemi, krok po kroku',
  'Build a tour': 'Zbuduj turniej',
  'Pick the cities, order the races': 'Wybierz miasta, ułóż kolejność wyścigów',
  'not surveyed': 'brak szkicu',
  '{n} races': { one: '{n} wyścig', few: '{n} wyścigi', many: '{n} wyścigów' },
  unknown: 'nieznany',
  archived: 'archiwalny',
  curated: 'polecany',
  'Most popular tours': 'Najpopularniejsze turnieje',
  'All tours': 'Wszystkie turnieje',
  'Thumbs up ({n})': 'Kciuk w górę ({n})',
  'Thumbs down ({n})': 'Kciuk w dół ({n})',
  'You cannot vote on your own tour.': 'Nie możesz głosować na własny turniej.',
  'Could not vote.': 'Nie udało się zagłosować.',
  'Edit {name}': 'Edytuj {name}',
  'A lobby code is four characters.': 'Kod lobby ma cztery znaki.',
  'Entering ': 'Wybrano: ',
  'Joining a race': 'Dołączasz do wyścigu',
  'Lobby ': 'Lobby ',
  'Join the lobby': 'Dołącz do lobby',
  'A driver needs a name.': 'Kierowca musi mieć imię.',
  'Car colour {hex}': 'Kolor auta {hex}',

  // tourBuilder.ts
  Name: 'Nazwa',
  Races: 'Wyścigi',
  'New tour': 'Nowy turniej',
  'Kraków Cup': 'Puchar Krakowa',
  'Add a race': 'Dodaj wyścig',
  'Delete this tour': 'Usuń ten turniej',
  'To continue': 'Żeby przejść dalej',
  'Edit “{name}”': 'Edytuj „{name}”',
  'Give the tour a name': 'Nazwij turniej',
  'The tour needs a name — it is what everybody sees on the shelf. Type one above.':
    'Turniej potrzebuje nazwy — to ją wszyscy widzą na półce. Wpisz ją powyżej.',
  'The tour has no name yet. Go back to the first step and give it one.':
    'Turniej nie ma jeszcze nazwy. Wróć do pierwszego kroku i ją nadaj.',
  'Add at least one race': 'Dodaj co najmniej jeden wyścig',
  'A tour with no races has nothing to drive. Press “Add a race” to pick the first one.':
    'W turnieju bez wyścigów nie ma czego jechać. Naciśnij „Dodaj wyścig”, żeby wybrać pierwszy.',
  'There are no races in this tour yet. Go back a step and add one.':
    'W tym turnieju nie ma jeszcze wyścigów. Wróć o krok i dodaj jakiś.',
  'Be signed in': 'Zaloguj się',
  'Saving a tour needs an account, so that it has somebody to belong to and nobody else can change it. Press “Sign in” above — your races are kept while you do.':
    'Do zapisania turnieju potrzebne jest konto — żeby miał właściciela i nikt inny nie mógł go zmienić. Naciśnij „Zaloguj się” powyżej — twoje wyścigi poczekają.',
  'Saved on the server': 'Zapisano na serwerze',
  'Step {n} of {total}': 'Krok {n} z {total}',
  'Saving…': 'Zapisywanie…',
  'Save changes': 'Zapisz zmiany',
  'Save tour': 'Zapisz turniej',
  'The tour’s name': 'Nazwa turnieju',
  'Name your tour': 'Nazwij swój turniej',
  'A tour is a playlist of races run back to back for points, Mario Kart style. Everybody on this server can race it; only you can change it.':
    'Turniej to playlista wyścigów jechanych jeden po drugim, o punkty — w stylu Mario Kart. Każdy na tym serwerze może się w nim ścigać, ale zmienić go możesz tylko ty.',
  'Tour name': 'Nazwa turnieju',
  'Up to 48 characters. It is what everybody sees on the shelf.':
    'Do 48 znaków. To ją wszyscy widzą na półce.',
  'Add the races': 'Dodaj wyścigi',
  'Up to {max}, raced in this order. Each one is a built-in region or a box you draw on the map, and you can shape its route as you add it.':
    'Najwyżej {max}, jechane w tej kolejności. Każdy to gotowy obszar albo prostokąt narysowany na mapie, a jego trasę ułożysz od razu przy dodawaniu.',
  'Save the tour': 'Zapisz turniej',
  'Check it over. Saving puts it on the shelf for everybody on this server, and selects it in your lobby.':
    'Sprawdź wszystko. Po zapisaniu turniej trafi na półkę dla wszystkich na tym serwerze i zostanie wybrany w twoim lobby.',
  'Saved as ': 'Autor: ',
  'Saving a tour needs an account. You can build it now and sign in before you save.':
    'Do zapisania turnieju potrzebne jest konto. Możesz zbudować go już teraz, a zalogować się przed zapisem.',
  'Untitled tour': 'Turniej bez nazwy',
  '{n} of {max} races': '{n} z {max} wyścigów',
  'A tour holds at most {n} races. Remove one to make room for another.': {
    one: 'Turniej mieści tylko jeden wyścig. Usuń go, żeby zrobić miejsce na inny.',
    few: 'Turniej mieści najwyżej {n} wyścigi. Usuń któryś, żeby zrobić miejsce na inny.',
    many: 'Turniej mieści najwyżej {n} wyścigów. Usuń któryś, żeby zrobić miejsce na inny.',
  },
  'Add race {n} to “{name}”': 'Dodaj wyścig {n} do „{name}”',
  'Add race {n}': 'Dodaj wyścig {n}',
  'Add to tour': 'Dodaj do turnieju',
  'Race {n}': 'Wyścig {n}',
  'Save race': 'Zapisz wyścig',
  'No races yet. Add the first one below.': 'Nie ma jeszcze wyścigów. Dodaj pierwszy poniżej.',
  'Move up': 'Przesuń w górę',
  'Move down': 'Przesuń w dół',
  Remove: 'Usuń',
  'The server would not save it: {reason}': 'Serwer nie chciał go zapisać: {reason}',
  'Could not reach the server to save ({error}). Your races are still here — try again.':
    'Nie udało się połączyć z serwerem, żeby zapisać ({error}). Twoje wyścigi nadal tu są — spróbuj ponownie.',
  'Delete “{name}”? This cannot be undone.': 'Usunąć „{name}”? Tego nie da się cofnąć.',
  'Could not delete it: {error}': 'Nie udało się go usunąć: {error}',
  'Built-in region': 'Gotowy obszar',
  '{name} · built in': '{name} · gotowy obszar',
  'starts {dir}': 'start: {dir}',
  '{n} placed checkpoints': {
    one: '{n} ustawiony punkt kontrolny',
    few: '{n} ustawione punkty kontrolne',
    many: '{n} ustawionych punktów kontrolnych',
  },
  '{n} checkpoints': { one: '{n} punkt kontrolny', few: '{n} punkty kontrolne', many: '{n} punktów kontrolnych' },

  // leaderboard.ts
  Points: 'Punkty',
  Wins: 'Wygrane',
  Distance: 'Dystans',
  'Fastest times': 'Najlepsze czasy',
  Podiums: 'Podia',
  Time: 'Czas',
  Set: 'Kiedy',
  'Everybody’s record': 'Wyniki wszystkich',
  Leaderboard: 'Ranking',
  Where: 'Gdzie',
  'Global leaderboard': 'Ranking ogólny',
  'Reading the board…': 'Wczytywanie rankingu…',
  'The board is not available.': 'Ranking jest niedostępny.',
  Racer: 'Kierowca',
  '{label} · {n} drivers': { one: '{label} · {n} kierowca', few: '{label} · {n} kierowców', many: '{label} · {n} kierowców' },
  'Nobody has set a time here yet.': 'Nikt jeszcze nie ustanowił tu czasu.',
  'No region has a recorded time yet. Finish a race while signed in and this fills up.':
    'Żaden obszar nie ma jeszcze zapisanego czasu. Ukończ wyścig po zalogowaniu, a ranking zacznie się zapełniać.',
  'Nobody has raced while signed in yet. The first person to finish one takes the top of this board.':
    'Nikt jeszcze nie ścigał się po zalogowaniu. Pierwsza osoba, która ukończy wyścig, trafi na szczyt rankingu.',
  'Only signed-in races are counted. ': 'Liczą się tylko wyścigi po zalogowaniu. ',
  'You are {rank}': 'Jesteś na {rank} miejscu',
  ' of {total}.': ' z {total}.',
  'You have no time here yet. Race this region and it lands on the board.':
    'Nie masz tu jeszcze czasu. Przejedź ten obszar, a trafisz do rankingu.',
  'You are not on this board yet — finish a race while signed in.':
    'Nie ma cię jeszcze w tym rankingu — ukończ wyścig po zalogowaniu.',
};
